import React, { useEffect, useState, useCallback, useContext } from "react";
import api, { BASE_URL } from "../../../Utils/api";
import EmailNotificacaoModal from "./EmailNotificacaoModal"; // Certifique-se de que o caminho está correto
import GridPadrao from "../../GridPadrao/GridPadrao";
import PageHeader from "../../PageHeader/PageHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../../Utils/GlobalContext";
import { useFeedback } from "../../Generals/Feedback/FeedbackContext";


function EmailNotificacao() {
  const { toast } = useFeedback();
  const [configuracoes, setConfiguracoes] = useState([]);
  const [selectedConfiguracao, setSelectedConfiguracao] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const token = localStorage.getItem("authToken");
  
  const permiteEdicao = "S"; // Ajuste para "S" ou "N" , de Configurações ou Cadastros Globais de qualquer entidade

  // Colunas da tabela com Cell personalizada para mostrar 'Ativo' ou 'Inativo'
  const columns = [
  //  { Header: "ID", accessor: "id" },
    { Header: "Nome", accessor: "nome" },
    { Header: "Servidor", accessor: "servidor" },
    { Header: "Porta", accessor: "porta" },
    { Header: "Usuário", accessor: "usuario" },
    { Header: "Situação", accessor: "situacao" },
  ];

  // Função para buscar configurações de email
  const fetchConfiguracoes = useCallback(() => {
    api
      .get(`${BASE_URL}/api/emailNotificacao/ListarConfiguracoesEmail/${entidadeID}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
         // Incluindo permiteEdicao em cada configuração
         const lista = Array.isArray(response.data?.data) ? response.data.data : [];
         const configuracoesComPermissao = lista.map(config => ({
          ...config,
          permiteEdicao: permiteEdicao // adiciona a permissão para cada item
        }));
        setConfiguracoes(configuracoesComPermissao);
      })
      .catch((error) => {
        console.error("Erro ao buscar configurações de e-mail:", error);
      });
  }, [token, entidadeID]);

  useEffect(() => {
    fetchConfiguracoes();
  }, [fetchConfiguracoes]);

  const handleEdit = async (configuracao) => {
    try {
      const response = await api.get(
        `${BASE_URL}/api/emailNotificacao/BuscarConfiguracaoEmail/${configuracao.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSelectedConfiguracao(response.data.data);
    } catch {
      setSelectedConfiguracao(configuracao);
    }
    setShowModal(true);
  };

  const handleAdd = () => {
    setSelectedConfiguracao(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedConfiguracao(null);
  };

  const handleTest = async (config, email) => {
    try {
      const response = await api.post(
        `${BASE_URL}/api/emailNotificacao/TestarConfiguracaoEmail/${email}`,
        { id: config.id }
      );
      toast.success(response.data.message); // Exibe o resultado do teste
    } catch (error) {
      toast.error(
        "Erro ao testar a configuração de e-mail: " +
          error.response.data.message
      );
    }
  };

  const temRegistroAtivo = configuracoes.some((c) => c.situacao === "A");

  return (
    <div>
      <PageHeader titulo="Configuração de Email" path="/EmailNotificacao" />
      <GridPadrao
        columns={columns}
        data={configuracoes}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onAdd={handleAdd}
        addDataTour="email-adicionar"
        addDisabled={temRegistroAtivo}
        addDisabledTitle="Já existe uma configuração ativa. Inative-a antes de adicionar uma nova."
        onTest={handleTest}
      />

      {/* Modal para adicionar/editar configuração de email */}
      <EmailNotificacaoModal
        show={showModal}
        handleClose={handleClose}
        configuracao={selectedConfiguracao}
        fetchConfiguracoes={fetchConfiguracoes}
      />
    </div>
  );
}

export default EmailNotificacao;